<!-- @format -->

<div
	[ngClass]="{
		'hmf-pb-xs hmf-pt-xxxs hmf-pr-s':
			chain.chainIdentifierAbbr === 'g3' &&
			productPrice?.minSavingPct !== '' &&
			!productPrice?.emptyPrice
	}"
	class="price">
	<div class="product-price-summary-container">
		<div
			id="pdp-price-summary"
			class="product-price-summary">
			@if (!productPrice?.emptyPrice && !showSelectOptionsText()) {
				<div
					itemprop="offers"
					itemscope=""
					itemtype="http://schema.org/Offer">
					<link
						itemprop="availability"
						href="http://schema.org/InStock" />
					<meta
						itemprop="priceCurrency"
						content="USD" />
					<meta
						itemprop="price"
						content="{{ productPrice?.minOfferPrice }}" />
					@if (
						productPrice?.minListPrice > productPrice?.minOfferPrice &&
						chain.chainIdentifierAbbr === 'g3'
					) {
						<div class="hmf-body-m label-secondary-subtle-static hmf-mb-xxxs">
							<span>Comparable Value</span>
							{{ productPrice?.minListPrice | currency }}
							@if (productPrice?.maxListPrice > productPrice?.minListPrice) {
								<span>- {{ productPrice?.maxListPrice | currency }}</span>
							}
							<shared-components-tool-tip
								class="comparable-value-tooltip"
								[hmfIcon]="'alert-info-filled'"
								textBody="Our “Comparable Value” price reflects the price at which we formerly offered this product, or in some instances, is based on a comparison by our experienced buyers of the offer price of the same or comparable merchandise elsewhere in the marketplace.  As prices often fluctuate, we cannot guarantee that the Comparable Value price reflects the prevailing market price at any given time in any given geographic area.  Some Comparable Value prices may not have been in effect during the past 90 days, and intermediate markdowns may have been taken. Limited quantities, while supplies last.  We therefore encourage you to do your own comparison shopping to determine the type of value we offer our athletes.">
							</shared-components-tool-tip>
						</div>
					}
					<div
						[ngClass]="{
							'hmf-display-flex hmf-flex-wrap hmf-align-items-center':
								isEnhancedSalesPriceEnable
						}">
						<div
							id="offer-price"
							class="hmf-mb-xxxs hmf-header-bold-l"
							[ngClass]="{
								'markdown-clearance-price-color':
									productPrice?.minListPrice &&
									(productPrice?.minListPrice > productPrice?.minOfferPrice ||
										productPrice?.maxListPrice > productPrice?.maxOfferPrice),
								'hmf-mr-xxs': isEnhancedSalesPriceEnable
							}">
							@if (myCustomizerTotalPrice() === undefined) {
								<span class="product-price">{{
									productPrice?.minOfferPrice | currency
								}}</span>
							}
							@if (
								productPrice?.maxOfferPrice > productPrice?.minOfferPrice &&
								myCustomizerTotalPrice() === undefined
							) {
								<span class="product-price-max">
									- {{ productPrice?.maxOfferPrice | currency }}</span
								>
							}
							@if (myCustomizerTotalPrice() !== undefined) {
								<span class="product-price">{{
									myCustomizerTotalPrice() | currency
								}}</span>
							}
							@if (
								chain.chainIdentifierAbbr === 'g3' &&
								productPrice?.minSavingPct !== '' &&
								!isEnhancedSalesPriceEnable
							) {
								<span class="hmf-body-l hmf-ml-xxs">
									{{ productPrice?.minSavingPct }}%
									@if (productPrice?.maxSavingPct > productPrice?.minSavingPct) {
										<span>- {{ productPrice?.maxSavingPct }}%</span>
									}
									Savings
								</span>
							}
						</div>
						<div
							class="hmf-display-flex hmf-body-m"
							[ngClass]="{ 'hmf-mb-xxxs hmf-mr-xxs': isEnhancedSalesPriceEnable }">
							@if (productPrice?.minListPrice && chain.chainIdentifierAbbr !== 'g3') {
								<span class="price-list">
									@if (
										productPrice?.minListPrice > productPrice?.minOfferPrice ||
										productPrice?.maxListPrice > productPrice?.minListPrice
									) {
										<span
											[ngClass]="
												chain?.chainIdentifierAbbr === 'pl'
													? ' pl-price-spacing'
													: ''
											"
											>{{ productPrice?.minListPrice | currency }}</span
										>
									}
									@if (productPrice?.maxListPrice > productPrice?.minListPrice) {
										<span> - {{ productPrice?.maxListPrice | currency }}</span>
									}
								</span>
								@if (
									productPrice?.minListPrice > productPrice?.minOfferPrice &&
									chain.chainIdentifierAbbr !== 'g3'
								) {
									<span class="label-secondary-subtle-static">*</span>
								}
							}
						</div>
					</div>
					@if (
						(productPrice?.maxSavingPct || productPrice?.minSavingPct) &&
						isEnhancedSalesPriceEnable
					) {
						<div class="hmf-body-bold-s hmf-mb-xxxs">
							<span
								class="discount-sale-price label-inverse-base hmf-px-xxxs hmf-display-inline-flex">
								Save
								@if (productPrice?.maxSavingPct > productPrice?.minSavingPct) {
									up to
									{{ productPrice?.maxSavingPct }}%
								} @else if (
									productPrice?.maxOfferPrice > productPrice?.minOfferPrice &&
									(productPrice?.minListPrice > productPrice?.minOfferPrice ||
										productPrice?.maxListPrice > productPrice?.maxOfferPrice)
								) {
									up to {{ productPrice?.minSavingPct }}%
								} @else {
									{{ productPrice?.minSavingPct }}%
								}
							</span>
						</div>
					}
				</div>
			}

			@if (productPrice?.emptyPrice && !showSelectOptionsText()) {
				<div>
					@if (chain.chainIdentifierAbbr === 'g3') {
						<div class="hmf-body-m label-secondary-subtle-static hmf-mb-xxxs">
							Comparable Value {{ productPrice?.minListPrice | currency }}
							@if (productPrice?.maxListPrice > productPrice?.minListPrice) {
								<span>- {{ productPrice?.maxListPrice | currency }}</span>
							}
							<shared-components-tool-tip
								class="comparable-value-tooltip"
								[hmfIcon]="'alert-info-filled'"
								textBody="Our “Comparable Value” price reflects the price at which we formerly offered this product, or in some instances, is based on a comparison by our experienced buyers of the offer price of the same or comparable merchandise elsewhere in the marketplace.  As prices often fluctuate, we cannot guarantee that the Comparable Value price reflects the prevailing market price at any given time in any given geographic area.  Some Comparable Value prices may not have been in effect during the past 90 days, and intermediate markdowns may have been taken. Limited quantities, while supplies last.  We therefore encourage you to do your own comparison shopping to determine the type of value we offer our athletes.">
							</shared-components-tool-tip>
						</div>
					}
					<div>
						<span class="hmf-mb-xxxs hmf-header-bold-l">See Price In Cart</span>
						<shared-components-tool-tip
							class="hmf-ml-xxxs"
							[hmfIcon]="'alert-info-filled'"
							textHeader="Why Don’t We Show The Price?"
							textBody="As a retailer, we set our own prices independently, but some manufacturers restrict how we may communicate those prices. In some cases the manufacturer does not allow us to show you our price until the item is in your cart.">
						</shared-components-tool-tip>
					</div>
				</div>
			}
			<!-- For color sku pricing feature -->
			@if (showSelectOptionsText()) {
				<div class="product-price">
					<span class="hmf-mb-xxxs hmf-header-bold-l hmf-mr-xs"
						>Select Options to See Price</span
					>
					@if (
						(productPrice?.minListPrice ||
							(productPrice?.emptyPrice && productPrice?.maxListPrice)) &&
						chain.chainIdentifierAbbr !== 'g3'
					) {
						<span class="hmf-mb-xxxs hmf-header-bold-l price-list">
							<span
								[ngClass]="
									chain?.chainIdentifierAbbr === 'pl' ? ' pl-price-spacing' : ''
								"
								>{{ productPrice?.maxListPrice | currency }}</span
							>
						</span>
					}
				</div>
			}
		</div>
	</div>
</div>
